import { render, staticRenderFns } from "./PropostaAdd.vue?vue&type=template&id=4aa0d304&scoped=true"
import script from "./PropostaAdd.vue?vue&type=script&lang=js"
export * from "./PropostaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa0d304",
  null
  
)

export default component.exports